export default "__VITE_ASSET__LOi3Azyw__"